import { useTranslation } from "react-i18next"

import { Label } from "@/components/ui/label"
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select"
import { useVoiceSettings } from "@/hooks/use-voice-settings"

export function VoiceSelector() {
  const { t } = useTranslation()
  const { selectedVoice, setSelectedVoice, voices } = useVoiceSettings()

  const selectedVoiceData = voices.find((v) => v.id === selectedVoice)
  const selectVoiceLabel = t("settings.voice_mode_select_voice")

  return (
    <section className="flex flex-col gap-2">
      <Label className="text-sm font-medium">{t("settings.voice_mode_voice")}</Label>
      <Select
        value={selectedVoice}
        onValueChange={(v) => setSelectedVoice(v as typeof selectedVoice)}
      >
        <SelectTrigger className="h-auto min-h-[2.5rem] w-full py-2 [&>span]:line-clamp-none">
          <SelectValue placeholder={selectVoiceLabel}>
            {selectedVoiceData ? (
              <div className="flex flex-col items-start gap-0.5 text-left">
                <span className="leading-tight font-medium">{t(selectedVoiceData.nameKey)}</span>
                <span className="text-muted-foreground text-xs leading-tight">
                  {t(selectedVoiceData.descriptionKey)}
                </span>
              </div>
            ) : (
              selectVoiceLabel
            )}
          </SelectValue>
        </SelectTrigger>
        <SelectContent className="max-h-[50vh]" position="popper" sideOffset={4}>
          {voices.map((voice) => (
            <SelectItem key={voice.id} className="py-2.5" value={voice.id}>
              <div className="flex flex-col items-start gap-0.5">
                <span className="leading-tight font-medium">{t(voice.nameKey)}</span>
                <span className="text-muted-foreground text-xs leading-tight">
                  {t(voice.descriptionKey)}
                </span>
              </div>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <p className="text-muted-foreground text-xs leading-relaxed">
        {t("settings.voice_mode_voice_description")}
      </p>
    </section>
  )
}
